import DealerEntitiesFactory from '../../dealer/Entities/factory.js'
import factoryLogger from '../../logger/index.js'
import SeoMappersFactory from '../Mappers/factory.js'
import {SeoRepositoriesFactory} from '../Repositories/factory.js'
import {SeoRequestsFactory} from '../Requests/factory.js'
import SeoServicesFactory from '../Services/factory.js'
import {GetDealerStructuredDataUseCase} from './GetDealerStructuredDataUseCase.js'
import {GetMakeModelFaqsUseCase} from './GetMakeModelFaqsUseCase.js'
import {GetSeoDataUseCase} from './GetSeoDataUseCase.js'
import {GetStaticFaqsSeoUseCase} from './GetStaticFaqsSeoUseCase.js'
import GetTagcloudSeoUseCase from './GetTagcloudSeoUseCase.js'

export default class SeoUseCasesFactory {
  static getMakeModelFaqsUseCase = ({config}) =>
    new GetMakeModelFaqsUseCase({
      config,
      makeModelFaqsRequestFactory: SeoRequestsFactory.makeModelFaqsRequest,
      httpSeoRepository: SeoRepositoriesFactory.hTTPSeoRepository({config})
    })

  static getStaticFaqsSeoUseCase = ({config}) =>
    new GetStaticFaqsSeoUseCase({
      config,
      httpSeoRepository: SeoRepositoriesFactory.hTTPSeoRepository({config})
    })

  static getTagcloudSeoUseCase = ({config}) =>
    new GetTagcloudSeoUseCase({
      config,
      log: factoryLogger({prefix: 'GetTagcloudSeoUseCase'}),
      fromJsonToTagCloudSeoRequestSeoMapper: SeoMappersFactory.fromJsonToTagCloudSeoRequestSeoMapper({config}),
      getTagcloudSeoService: SeoServicesFactory.getTagcloudSeoService({config}),
      seoDataRequestFactory: SeoRequestsFactory.seoDataRequest
    })

  static getSeoDataUseCase = ({config}) =>
    new GetSeoDataUseCase({
      config,
      seoDataRequestFactory: SeoRequestsFactory.seoDataRequest,
      getSeoDataService: SeoServicesFactory.getSeoDataService({
        config
      })
    })

  static getDealerStructuredDataUseCase = ({config}) =>
    new GetDealerStructuredDataUseCase({
      config,
      dealerEntityFactory: DealerEntitiesFactory.dealerEntity,
      fromDealerEntityToStructuredDataValueObjectMapper:
        SeoMappersFactory.fromDealerEntityToStructuredDataValueObjectMapper({
          config
        })
    })
}
